import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes/theme";

type ProposalMoreActionsIconProps = IconT & {
  circleFill?: string;
};

export default function ProposalMoreActionsIcon({
  height = "24",
  width = "24",
  fill = theme.colors["darkest-blue"],
  circleFill = theme.colors["athens-gray"],
}: ProposalMoreActionsIconProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill={circleFill} />
      <path
        d="M11.9998 12.8332C12.4601 12.8332 12.8332 12.4601 12.8332 11.9998C12.8332 11.5396 12.4601 11.1665 11.9998 11.1665C11.5396 11.1665 11.1665 11.5396 11.1665 11.9998C11.1665 12.4601 11.5396 12.8332 11.9998 12.8332Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9998 7.00016C12.4601 7.00016 12.8332 6.62707 12.8332 6.16683C12.8332 5.70659 12.4601 5.3335 11.9998 5.3335C11.5396 5.3335 11.1665 5.70659 11.1665 6.16683C11.1665 6.62707 11.5396 7.00016 11.9998 7.00016Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9998 18.6667C12.4601 18.6667 12.8332 18.2936 12.8332 17.8333C12.8332 17.3731 12.4601 17 11.9998 17C11.5396 17 11.1665 17.3731 11.1665 17.8333C11.1665 18.2936 11.5396 18.6667 11.9998 18.6667Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
